import { ReactElement } from "react";
import { useFeatureFlagToken } from "../../../hooks/useFeatureFlag";
import { FeatureFlagName } from "../../../types/feature-flags/featureFlag";

export function HideBehindFeature({
  name,
  children,
}: {
  name: FeatureFlagName;
  children: ReactElement;
}) {
  const isFeatureEnabled = useFeatureFlagToken(name);

  if (!isFeatureEnabled) {
    return null;
  }

  return children;
}
